var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxHeaderReddish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BoxHeading",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "0 0 424.295 56.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Heading",
    d: "M108.019,49.793q61.8-1.988,123.543,1.1c21.174,1.071,42.335,2.454,63.551,2.817,20.67.356,41.1-1.133,61.706-2.16,22.468-1.118,44.975-1.744,67.477-1.7L423.164.442l-71.6,1.565L281.1,0,210.648,4.646l-70.458-.19L69.729.767.157,2.166,0,56.426c35.91-3.145,71.931-5.47,108.019-6.632",
    transform: "translate(0 0.001)",
    fill: "#881840"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3Arrows",
    "data-name": "3Arrows",
    transform: "translate(-3.204 -6.917)",
    opacity: 0.31,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_746",
    "data-name": "Tracciato 746",
    d: "M427.522,452.343l9.671,16.992,8.607-19.294Zm9.671,14.393L429.632,453.5l14.089-1.727Z",
    transform: "translate(-409.63 -435)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_747",
    "data-name": "Tracciato 747",
    d: "M456.522,461.144,439.2,463.133,450,479.967Zm-15.208,3.146,12.9-1.157-4.7,13.5Z",
    transform: "translate(-407.411 -433.047)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_748",
    "data-name": "Tracciato 748",
    d: "M436.647,485.53l6.066-17.33-14.384,2.182Zm0-2.946-6.47-11.265,10.371-.937Z",
    transform: "translate(-410.182 -432.188)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxHeaderReddish);
export default __webpack_public_path__ + "static/media/BoxHeader_reddish.43ecdbf71862fe8938ecca1bb23cf2c0.svg";
export { ForwardRef as ReactComponent };